import { useOrg } from 'contexts/OrgContext'

export const useOrgQueryKey = (queryKey: string) => {
  const { org } = useOrg()

  return [queryKey, org]
}
